import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./GarhwaliCategories.module.css";
import { useEbooksByGenreName } from "../../hooks/useEbooksHooks";
import Loading from "../../common/HousGlass Loader/Loading";

function GarhwaliEbookCategoriesGrid({ categoryName }) {
  const navigate = useNavigate();
  const { ebooks, isLoading, error } = useEbooksByGenreName(categoryName);

  // Check loading and error states
  if (isLoading)
    return (
      <div>
        <Loading />
      </div>
    );
  if (error) return null;

  // Use ebooks directly from the hook
  const books = ebooks || [];



  return (
    books.length > 0 && (
      <div className={styles.container}>
        <div className={styles.book_grid_container}>
         
          
          <div className={styles.book_grid}>
            {books.map((book) => (
              <div key={book.id} className={styles.grid_item}>
                <img
                  src={book.cover_image_url_for_computer}
                  alt={book.title}
                  className={styles.book_image}
                  onClick={() =>
                    navigate(
                      book.series_id
                        ? `/book-details/${book.slug}`
                        : `/book-detail/${book.slug}`
                    )
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  );
}

export default GarhwaliEbookCategoriesGrid;